module.exports = __webpack_public_path__ + "static/media/pricing_tool_banner_deep.5ff7f38f.jpg";